import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const ChatRoute = [
    {
        path: '/chat',
        component: React.lazy(() => import('./Chat.js')),
        auth: AuthRoles.editor,
    }
]

export default ChatRoute;